<template lang="pug">
  .spinner.spinner--sockerv-bind(:style="styles")
    .spinner-inner(v-bind:style="innerStyles")
      .cube.panelLoad
        .cube-face.cube-face-front  B
        .cube-face.cube-face-left   I
        .cube-face.cube-face-bottom X
        .cube-face.cube-face-right  T
        .cube-face.cube-face-back   E
        .cube-face.cube-face-top    R
</template>

<script>
export default {
  props: {
    size: {
      default: '150px'
    }
  },
  computed: {
    innerStyles () {
      let size = parseInt(this.size) / 2
      return {
        transform: 'scale(' + (size / 75) + ')'
      }
    },
    styles () {
      return {
        width: this.size,
        height: this.size
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/components/spinner/index.vue